module.exports = __webpack_public_path__ + "img/lens-167-minus-07.af269442.png";